import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonSpinner, IonProgressBar } from '@ionic/angular/standalone';
import { LoaderService } from 'src/app/core/services/loader.service';
import { ThemeService } from 'src/app/core/services/theme.service';
import { stringConstant } from 'src/app/core/services/stringConstants';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IonSpinner, IonProgressBar],
})
export class LoaderComponent {
  protected readonly loaderService = inject(LoaderService);
  private readonly themeService = inject(ThemeService);
  public readonly constant = stringConstant;

  // Signal-based: loader, mainLoader, loaderMessage read directly from service signals in template
  get horizontalLogoSrc(): string {
    return this.themeService.isDarkTheme()
      ? this.constant.bharatLawHorizontalDark
      : this.constant.bharatLawHorizontal;
  }
}
